export enum QualificationTrainingsStatus {
  open = 'open',
  pending = 'pending',
  booked = 'booked',
  inProgress = 'inProgress',
  paused = 'paused',
  completedSuccess = 'completedSuccess',
  completedFailed = 'completedFailed',
  resultAccepted = 'resultAccepted',
  resultRejected = 'resultRejected',
  cancelled = 'cancelled',
  declined = 'declined',
  qualificationCreated = 'qualificationCreated',
}

export type UpdateTrainingQualificationStatus =
  | QualificationTrainingsStatus.open
  | QualificationTrainingsStatus.pending
  | QualificationTrainingsStatus.booked
  | QualificationTrainingsStatus.inProgress
  | QualificationTrainingsStatus.paused
  | QualificationTrainingsStatus.completedSuccess
  | QualificationTrainingsStatus.completedFailed
  | QualificationTrainingsStatus.resultAccepted
  | QualificationTrainingsStatus.resultRejected;

export interface QualificationTrainingsStatusConfig {
  backgroundColor?: string;
  borderColor?: string;
  translationKey: string;
}

export const qualificationTrainingsStatusMapping: Record<
  QualificationTrainingsStatus,
  QualificationTrainingsStatusConfig
> = {
  [QualificationTrainingsStatus.open]: {
    translationKey: 'page.training-qualifications.status.open',
  },
  [QualificationTrainingsStatus.pending]: {
    translationKey: 'page.training-qualifications.status.pending',
  },
  [QualificationTrainingsStatus.booked]: {
    translationKey: 'page.training-qualifications.status.booked',
  },
  [QualificationTrainingsStatus.inProgress]: {
    backgroundColor: 'var(--blue-1)',
    borderColor: 'var(--blue-4)',
    translationKey: 'page.training-qualifications.status.in_progress',
  },
  [QualificationTrainingsStatus.paused]: {
    backgroundColor: 'var(--blue-1)',
    borderColor: 'var(--blue-4)',
    translationKey: 'page.training-qualifications.status.paused',
  },
  [QualificationTrainingsStatus.completedSuccess]: {
    backgroundColor: 'var(--gold-1)',
    borderColor: 'var(--gold-4)',
    translationKey: 'page.training-qualifications.status.completed_success',
  },
  [QualificationTrainingsStatus.completedFailed]: {
    backgroundColor: 'var(--volcano-1)',
    borderColor: 'var(--volcano-4)',
    translationKey: 'page.training-qualifications.status.completed_failed',
  },
  [QualificationTrainingsStatus.resultAccepted]: {
    backgroundColor: 'var(--green-1)',
    borderColor: 'var(--green-4)',
    translationKey: 'page.training-qualifications.status.result_accepted',
  },
  [QualificationTrainingsStatus.resultRejected]: {
    backgroundColor: 'var(--volcano-1)',
    borderColor: 'var(--volcano-4)',
    translationKey: 'page.training-qualifications.status.result_rejected',
  },
  [QualificationTrainingsStatus.cancelled]: {
    backgroundColor: 'var(--red-1)',
    borderColor: 'var(--red-4)',
    translationKey: 'page.training-qualifications.status.cancelled',
  },
  [QualificationTrainingsStatus.declined]: {
    backgroundColor: 'var(--red-1)',
    borderColor: 'var(--red-4)',
    translationKey: 'page.training-qualifications.status.declined',
  },
  [QualificationTrainingsStatus.qualificationCreated]: {
    backgroundColor: 'var(--purple-1)',
    borderColor: 'var(--purple-4)',
    translationKey: 'page.training-qualifications.status.qualification_created',
  },
};
